/* globals GIG */

'use strict';

/*
  TODO: convert to Preact code
  - need to re-work components/sticky_footer/ to reduce complexity/payload
*/
const { addCartHandler, updateAndSubmitCartForm } = require('./cart');
const {
  addEventPipe,
  addBuyButtonClickHandler,
  addOptionsClickHandler,
  addToCartButtonClickHandler,
  handleGoodsWarrantyModalClose,
  handleOptionChangeForHBWPrePurchase,
} = require('./event_handlers');

const modalHandlers = require('./modal_handlers');
const renderCheckScheduleButton = require('./check_schedule');

const openGoodsWarrantyModal = function openGoodsWarrantyModal() {
  const $goodsWarrantyModalCta = document.querySelector('.add-warranty-cta');
  const $goodsWarrantyModal = document.querySelector('#goods-warranty-modal');

  $goodsWarrantyModal.dataset.fromBuy = true;
  $goodsWarrantyModalCta.style.display = 'block';
  GIG.Modal.open({ id: 'goods-warranty-modal' });
};

const BuyButtonForm = {
  hideProcessingLoader({ target }) {
    target.classList.remove('loading');

    // need to allow setting of disabled to happen first
    window.requestAnimationFrame(() => target.removeAttribute('disabled'));
  },

  showProcessingLoader({ target }) {
    target.classList.add('loading');

    // need to allow the form to submit first
    window.requestAnimationFrame(() => target.setAttribute('disabled', true));
  },

  sendToCart({ preventCheckout, optionData }, event) {
    event.preventDefault();
    if (preventCheckout) {
      this.hideProcessingLoader(event);
      return false;
    }
    const { optionUuid } = optionData;
    const dealUuid = this.data.dealUuid;

    updateAndSubmitCartForm(
      {
        dealUuid,
        optionUuid,
      },
      event
    );
    return null;
  },
  /**
   * trigger handleOptionChangeForHBWPrePurchase if user selects another option
   */
  setupUpdateHBWPrePurchaseUrl() {
    const $checkAvailabilityButton = document.querySelector(
      '.check-schedule-btn'
    );
    if ($checkAvailabilityButton) {
      this.eventPipe.on('option_updated', handleOptionChangeForHBWPrePurchase);
    }
  },
  checkAndSendToCheckout(
    { isGift, goodsWarrantyUrl, optionData, preventCheckout },
    event
  ) {
    event.preventDefault();
    if (preventCheckout) {
      this.hideProcessingLoader(event);
      return false;
    }

    let buyUrl = goodsWarrantyUrl || optionData.buyUrl;
    const { optionUuid } = optionData;
    const dealUuid = this.data.dealUuid;
    const $goodsWarrantyModal = document.querySelector('#goods-warranty-modal');

    if (
      $goodsWarrantyModal &&
      !goodsWarrantyUrl &&
      !$goodsWarrantyModal.dataset.fromBuy &&
      this.data.showGoodsWarrantyModalOnBuy
    ) {
      this.sourceBuyEvent = event;
      openGoodsWarrantyModal();
      this.hideProcessingLoader(event);
      return false;
    }

    if (this.data.hasCart && !goodsWarrantyUrl && !isGift) {
      updateAndSubmitCartForm(
        {
          dealUuid,
          optionUuid,
        },
        event
      );
    } else {
      if (isGift) {
        buyUrl += '&gift=true';
      }

      window.location = buyUrl;
    }

    return false;
  },

  setupOptionsClickHandler() {
    addOptionsClickHandler.call(this);
  },

  setupAddCartClickHandler() {
    addToCartButtonClickHandler.call(this, this.sendToCart.bind(this));
  },

  setupBuyButtonClickHandler() {
    const sendToCheckoutOrNull = this.data.hasMultiOption
      ? this.checkAndSendToCheckout.bind(this)
      : null;

    addBuyButtonClickHandler.call(this, sendToCheckoutOrNull);
    this.eventPipe.on('buy_button_clicked', this.showProcessingLoader);
  },

  setupGoodsWarrantyModalHandler() {
    const sendToCheckoutOrNull = this.data.hasMultiOption
      ? this.checkAndSendToCheckout.bind(this)
      : null;

    const fun = handleGoodsWarrantyModalClose.bind(this, sendToCheckoutOrNull);
    GIG.Modal.onClose(
      () => requestAnimationFrame(fun),
      'goods-warranty-modal',
      false
    );
  },

  setupGoodsWarrantyCheckboxHandler() {
    const BuyButtonEventPipe = this.eventPipe;
    BuyButtonEventPipe.on(
      'toggleAddToCartButton',
      ({ showAddToCartButton }) => {
        const $addToCartButtonContainer = $('#sticky-footer .add-cart-button');
        if (showAddToCartButton) {
          $addToCartButtonContainer.removeClass('hide');
        } else {
          $addToCartButtonContainer.addClass('hide');
        }
      }
    );
  },

  init({ buyButtonForm = {}, cart }, done) {
    this.data = buyButtonForm;
    this.data.cart = cart;
    addEventPipe.call(this);

    this.setupGoodsWarrantyCheckboxHandler();
    this.setupGoodsWarrantyModalHandler();
    this.setupBuyButtonClickHandler();
    this.setupOptionsClickHandler();
    this.setupAddCartClickHandler();
    this.setupUpdateHBWPrePurchaseUrl();

    const { dealUuid } = buyButtonForm;
    addCartHandler.call(this, { ...cart, dealUuid });

    if (this.data.hasModal) {
      modalHandlers.call(this);
    }

    renderCheckScheduleButton(buyButtonForm);

    return done();
  },
};

module.exports = BuyButtonForm;
